import {
  NORMALIZED_SKU_CODES,
  NetSuiteAssetStatus,
  Site,
  SkuCode,
  Skus,
} from 'types'

const normalizeSkuCode = (skuCode: string): string =>
  NORMALIZED_SKU_CODES.includes(skuCode as SkuCode) ||
  skuCode === Skus.K8FamilySkuCode
    ? Skus.K8SkuCode
    : skuCode.toUpperCase()

export const siteHasActiveK8License = (
  site: Site | null | undefined,
): boolean => {
  if (!site?.netSuiteAssets?.length) {
    return false
  }

  return site.netSuiteAssets.some(netSuiteAsset => {
    if (
      netSuiteAsset.status === NetSuiteAssetStatus.Expired ||
      netSuiteAsset.status === NetSuiteAssetStatus.Canceled
    ) {
      return false
    }

    return (netSuiteAsset?.product?.programCodes || []).some(
      code => normalizeSkuCode(code) === Skus.K8SkuCode,
    )
  })
}
